import { mergeDeep } from "@root/utiles";

const getModules = (group = [], result = {}) => {
  group.forEach(item => {
    let key = item.replace(/(^\.\/)|(\.ts)/g, "");
    result[key] = file(item).default || file(item);
  });
  return result;
};

const file = (require as any).context("./modules", false, /\.ts$/);

const modules = getModules(file.keys());

export default mergeDeep(modules, {});
